import { z } from 'zod';
import {
    type NodeSocketCfg,
} from './base-node';
import { baseConnectionCfgSchema, connectionNodeConfigSchema } from './connection.zod';
import type { NodeCfg } from '../nodes';

export const isduWriteNodeCfgSchema = connectionNodeConfigSchema(baseConnectionCfgSchema.extend({
    kind: z.literal('isduWrite'),
    controlValues: baseConnectionCfgSchema.shape.controlValues.merge(z.object({
        channelNumber: z.number(),
        /** keyed by variable id, value is the data required to interface with the isdu index */
        isduVariables: z.record(z.object({
            // human readable name from the iodd file. for display purposes only
            name: z.string(),
            // the applet node needs all possible isdu variables to know what its available options are. we use this boolean to signal if the node intends on interfacing with it
            tracked: z.boolean(),
            dataKind: z.union([ z.literal('string'), z.literal('number'), z.literal('boolean') ]),
        })),
    })),
}));
interface ISDUWriteCfgSchema extends z.infer<typeof isduWriteNodeCfgSchema> {}

export const isduWriteNodeSocketCfg = {
    controlSockets: {
        inputs: (_cfg: NodeCfg<'isduWrite'>) => {
            const ret: {
                trigger: 'event';
            } = {
                trigger: 'event',
            };
            return ret;
        },
        outputs: (_cfg: NodeCfg<'isduWrite'>) => {
            return {};
        },
    },
    dataSockets: {
        outputs: (_cfg: NodeCfg<'isduWrite'>) => {
            return {};
        },
        inputs: (cfg: NodeCfg<'isduWrite'>) => {
            const ret: Record<`input_${string}`, 'string' | 'number' | 'boolean'> = {};
            for (const [ variableId, variableDetails ] of Object.entries(cfg.controlValues.isduVariables)) {
                if (variableDetails.tracked) {
                    ret[`input_${variableId}`] = variableDetails.dataKind;
                }
            }
            return ret;
        },
    },
} satisfies NodeSocketCfg<ISDUWriteCfgSchema>;
